import { useSearch } from "hooks/useFetch";
import React, { useState } from "react";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import CommonLayout from "./CommonLayout";
import { RootState } from "store";
import { useSelector } from "react-redux";
import ItemCard from "components/ItemCard/ItemCard";
import ItemCardLoading from "components/ItemCard/ItemCardLoading";

const AccountSavelists: React.FC = () => {
  const [shown, setShown] = useState<number>(8);
  const { likedProducts } = useSelector(
    (state: RootState) => state.likedProduct
  );
  const [data, loading] = useSearch("");
  const liked = data.filter((_, i) => {
    if (likedProducts) {
      return likedProducts.includes(_._id);
    }
    return [];
  });

  const renderSection1 = () => {
    return (
      <div className="space-y-6 sm:space-y-8">
        <div>
          <h2 className="text-3xl font-semibold">Tersimpan</h2>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div>
          <div className="mt-8">
            {loading ? (
              <div className="grid grid-cols-1 gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
                  <ItemCardLoading key={item}></ItemCardLoading>
                ))}
              </div>
            ) : liked && liked.length > 0 ? (
              <div className="grid grid-cols-1 gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                {liked
                  .filter((_, i) => i < shown)
                  .map((item) => (
                    <ItemCard key={item._id} data={item} />
                  ))}
              </div>
            ) : (
              <div>Tidak ada produk yang kamu sukai</div>
            )}
            <div className="flex mt-11 justify-center items-center">
              {liked && liked.length > 8 ? (
                <ButtonSecondary onClick={() => setShown((prev) => prev + 8)}>
                  Tunjukkan lebih banyak
                </ButtonSecondary>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <CommonLayout>{renderSection1()}</CommonLayout>
    </div>
  );
};

export default AccountSavelists;
